import React from 'react';

import { Tab, Tabs, Tooltip } from 'components';
import { Edit2, Eye } from 'iconsax-react';

import { useSelector, useTranslation } from 'third-party';

import { useSettings } from 'modules/setting';

import { settingSelectors } from 'selectors';

export default function MainTabsGroup() {
  const selectedMainTab = useSelector(settingSelectors.selectedMainTab);
  const { setSelectedMainTab } = useSettings();
  const { t } = useTranslation();

  const handleChange = (_: unknown, it: unknown) => {
    switch (it) {
      case 'preview':
      case 'editor':
        setSelectedMainTab(it);
        return;
      default:
        setSelectedMainTab('editor');
    }
  };

  return (
    <Tabs value={selectedMainTab} onChange={handleChange}>
      <Tab
        value="editor"
        label={
          <Tooltip title={t('emailDesigner.tabs.edit')}>
            <Edit2 variant="TwoTone" size="20" />
          </Tooltip>
        }
      />
      <Tab
        value="preview"
        label={
          <Tooltip title={t('emailDesigner.tabs.preview')}>
            <Eye variant="TwoTone" size="20" />
          </Tooltip>
        }
      />
    </Tabs>
  );
}
